import { render, staticRenderFns } from "./OrdersContainer.vue?vue&type=template&id=1b2f05e4&lang=pug"
import script from "./OrdersContainer.vue?vue&type=script&lang=js"
export * from "./OrdersContainer.vue?vue&type=script&lang=js"
import style0 from "./OrdersContainer.vue?vue&type=style&index=0&id=1b2f05e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports